'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Assert = require('./utility/Assert');

var _Assert2 = _interopRequireDefault(_Assert);

var _Plugin = require('./Plugin');

var _Plugin2 = _interopRequireDefault(_Plugin);

var _Minima = require('./Minima');

var _Minima2 = _interopRequireDefault(_Minima);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 服务注册对象
 * 
 * @export
 * @class ServiceRegistry
 */
var ServiceRegistry = function () {

    /**
     * 注册一条服务
     * 
     * @ignore
     * @param {string} serviceName 服务名称
     * @param {Object} serviceInstance 服务实例
     * @param {Plugin|Minima} serviceOwner 服务拥有者
     * @param {Object} properties 服务属性
     * @memberof ServiceRegistry
     */
    function ServiceRegistry(serviceName, serviceInstance, serviceOwner, properties) {
        (0, _classCallCheck3.default)(this, ServiceRegistry);

        _Assert2.default.notEmpty('serviceName', serviceName);
        _Assert2.default.notNull('serviceInstance', serviceInstance);
        _Assert2.default.notNull('serviceOwner', serviceOwner);

        if (!properties) {
            properties = {};
        }

        this._serviceName = serviceName;
        this._serviceInstance = serviceInstance;
        this._properties = properties;
        this._serviceOwner = serviceOwner;

        this.match = this.match.bind(this);
    }

    /**
     * 服务名称
     * 
     * @readonly
     * @memberof ServiceRegistry
     */


    (0, _createClass3.default)(ServiceRegistry, [{
        key: 'match',
        value: function match(name, properties) {
            if (!properties && this.name === name) {
                return true;
            }

            for (var serviceKeyWord in properties) {
                if (properties[serviceKeyWord] !== this.properties[serviceKeyWord]) {
                    return false;
                }
            }

            return true;
        }
    }, {
        key: 'serviceName',
        get: function get() {
            return this._serviceName;
        }

        /**
         * 服务实例
         * 
         * @readonly
         * @memberof ServiceRegistry
         */

    }, {
        key: 'serviceInstance',
        get: function get() {
            return this._serviceInstance;
        }

        /**
         * 服务属性
         * 
         * @readonly
         * @memberof ServiceRegistry
         */

    }, {
        key: 'properties',
        get: function get() {
            return this._properties;
        }

        /**
         * 服务拥有者
         * 
         * @type {Plugin|Minima}
         * @readonly
         * @memberof ServiceRegistry
         */

    }, {
        key: 'serviceOwner',
        get: function get() {
            return this._serviceOwner;
        }
    }]);
    return ServiceRegistry;
}();

exports.default = ServiceRegistry;
//# sourceMappingURL=ServiceRegistry.js.map